import { NgModule } from "@angular/core";
import { NgxPermissionsModule } from "ngx-permissions";
import { TranslocoModule } from "@ngneat/transloco";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "./material.module";
import { AsyncPipe, CommonModule, DatePipe, JsonPipe, NgClass, NgComponentOutlet, NgFor, NgIf, NgOptimizedImage, NgStyle, NgSwitch, NgSwitchCase } from "@angular/common";
import { ValidationHelper } from "../pipes/validationHelper.pipe";
import { ValidationErrorsDirective } from "../directives/validationErrors.directive";
import { DateToStringPipe } from "../pipes/date-to-string.pipe";
import { RowDateToDatePipe } from "src/app/shared/pipes/row-date-to-date.pipe";
import { LoadingDirective } from "../directives/loading.directive";
import { LoaderComponent } from "../components/loader/loader.component";
import { ButtonComponent } from "../components/button/button.component";
import { DropDownComponent } from "../components/drop-down/drop-down.component";
import { TruncateDirective } from "../directives/truncate.directive";
import { CustomToolTipDirective } from "../directives/tooltip-core";
import { TimeTransformerDefault } from "../pipes/time-format.pipe";
import { InputComponent } from "../components/input/input.component";
import { NumberToDecimalPipe } from "../pipes/number-to-decimal.pipe";



@NgModule({
  imports: [
    NgxPermissionsModule,
    TranslocoModule,
    ReactiveFormsModule,
    FormsModule,
    NgComponentOutlet,
    NgOptimizedImage,
    ValidationHelper,
    ValidationErrorsDirective,
    LoadingDirective,
    LoaderComponent,
    ButtonComponent,
    JsonPipe,
    DropDownComponent,
    MaterialModule,
    AsyncPipe,
    TruncateDirective,
    CustomToolTipDirective,
    InputComponent,
    DatePipe,
    CommonModule,
    NumberToDecimalPipe

  ],
  
  exports: [
    NgxPermissionsModule,
    TranslocoModule,
    ReactiveFormsModule,
    FormsModule,
    NgComponentOutlet,
    NgOptimizedImage,
    ValidationHelper,
    ValidationErrorsDirective,
    LoadingDirective,
    LoaderComponent,
    ButtonComponent,
    JsonPipe,
    DropDownComponent,
    MaterialModule,
    AsyncPipe,
    TruncateDirective,
    CustomToolTipDirective,
    InputComponent,
    DatePipe,
    CommonModule,
    NumberToDecimalPipe
  ],

  providers: [
    DateToStringPipe,
    RowDateToDatePipe,
    DatePipe,
    TimeTransformerDefault
  ],
  declarations: []
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
    };
  }
}
